// extracted by mini-css-extract-plugin
export var container = "styles-module--container--9db3c";
export var footerLinks = "styles-module--footer-links--4a6b5";
export var footerTop = "styles-module--footer-top--46556";
export var goToTop = "styles-module--go-to-top--3a8f1";
export var line = "styles-module--line--c9176";
export var socialIcon = "styles-module--social-icon--44ac4";
export var socialRow = "styles-module--social-row--4f35e";